export default "__VITE_ASSET__DOk4RACR__"